import * as logger from './logger';

const supportsLocalStorage = () => {
  return window && window.localStorage;
};

/** Read a value from local storage. */
export function read(key: string) {
  let item;
  if (supportsLocalStorage()) {
    try {
      item = JSON.parse(window.localStorage.getItem(key) || 'null');
    } catch (_err) {
      logger.error(`An error occurred reading "${key}" from local storage.`);
    }
  } else {
    logger.error(
      `Local Storage is not detected for the browser. Cannot read "${key}".`
    );
  }
  return item;
}

/** Write data to local storage. */
export function write(key: string, json: object | string) {
  if (supportsLocalStorage()) {
    window.localStorage.setItem(key, JSON.stringify(json));
  } else {
    logger.error(
      `Local Storage is not detected for the browser. Cannot write "${key}".`
    );
  }
}

/** Remove data from local storage. */
export function remove(key: string) {
  if (supportsLocalStorage()) {
    window.localStorage.removeItem(key);
  } else {
    logger.error(
      `Local Storage is not detected for the browser. Cannot remove "${key}".`
    );
  }
}
